export function animateTimer(nodes:HTMLElement[]) {
	let endOfDay = new Date();
	endOfDay.setHours(23,59,59,0);
	const target = endOfDay.getTime();

	setInterval(() => {
		const now = new Date().getTime();
		let distance = target - now;
		if (distance < 0) {
			distance = 0;
		}

		let hours:any = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes:any = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		let seconds:any = Math.floor((distance % (1000 * 60)) / 1000);

		if (hours < 10) {
			hours = '0' + hours;
		}
		if (minutes < 10) {
			minutes = '0' + minutes;
		}
		if (seconds < 10) {
			seconds = '0' + seconds;
		}

		const anzeige = `${hours}:${minutes}:${seconds}`;
		for (const node of nodes) {
			node.innerText = anzeige;
		}

	}, 1000)
}
